import * as React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';

export const MultiSelectField = (props) => {
  const [selectedValues, setSelectedValues] = React.useState([]);
  const { id, name, hintText, menuItems, onListChange, disabled } = props;
	

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // Ensure it's always an array
    setSelectedValues(typeof value === "string" ? value.split(",") : value);
	if (onListChange) {
		onListChange(typeof value === "string" ? value.split(",") : value);
	}
  };

  const _onCheck = (event) => {
		event.preventDefault();
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="multiple-select-label">{hintText}</InputLabel>
      <Select
        labelId={"multiple-select-label"}
        id={id}
        multiple
        value={selectedValues}
        onChange={handleChange}
		inputProps={{
			name
		}}
		disabled={disabled}
		renderValue={(selected) => selected.map(d => new Date(d).toLocaleDateString("en-GB")).join(', ')}
      >
		{menuItems.map((item, i) => (
			<MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>
				<Checkbox checked={selectedValues.indexOf(item.value) > -1} onChange={_onCheck} />
				{item.text}
			</MenuItem>
		))}
      </Select>
    </FormControl>
  );
};

